import { NULL } from "../../../../constants";
export default (function (_ref) {
  var operator = _ref.operator,
      values = _ref.values;

  if (values && values.includes(NULL)) {
    operator = operator === 'eq' ? 'empty' : 'notEmpty';
  }

  return {
    operator: operator,
    values: values
  };
});